export interface PlanTheme {
    /** Borda do card */
    border: string;
    /** Fundo do card */
    bg: string;
    /** Borda no hover */
    hoverBorder: string;
    /** Fundo no hover */
    hoverBg: string;
    /** Cor do nome do plano */
    nameColor: string;
    /** Botão assinar: bg + borda */
    buttonBase: string;
    /** Botão assinar: hover */
    buttonHover: string;
    /** Linha decorativa no topo do card */
    topLine: string;
}

const THEMES: Record<string, PlanTheme> = {
    bronze: {
        border: 'border-amber-700/55',
        bg: 'bg-amber-950/25',
        hoverBorder: 'hover:border-amber-600/70',
        hoverBg: 'hover:bg-amber-900/30',
        nameColor: 'text-amber-500',
        buttonBase: 'bg-amber-700/30 border border-amber-700/50 text-amber-100',
        buttonHover: 'hover:bg-amber-700/50',
        topLine: 'bg-gradient-to-r from-amber-800/0 via-amber-600/70 to-amber-800/0',
    },
    prata: {
        border: 'border-slate-400/50',
        bg: 'bg-slate-500/10',
        hoverBorder: 'hover:border-slate-300/65',
        hoverBg: 'hover:bg-slate-400/15',
        nameColor: 'text-slate-300',
        buttonBase: 'bg-slate-500/25 border border-slate-400/40 text-slate-100',
        buttonHover: 'hover:bg-slate-400/40',
        topLine: 'bg-gradient-to-r from-slate-500/0 via-slate-400/70 to-slate-500/0',
    },
    ouro: {
        border: 'border-yellow-500/55',
        bg: 'bg-yellow-500/10',
        hoverBorder: 'hover:border-yellow-400/70',
        hoverBg: 'hover:bg-yellow-500/15',
        nameColor: 'text-yellow-400',
        buttonBase: 'bg-yellow-500/25 border border-yellow-500/45 text-yellow-100',
        buttonHover: 'hover:bg-yellow-500/40',
        topLine: 'bg-gradient-to-r from-yellow-500/0 via-yellow-400/70 to-yellow-500/0',
    },
    diamante: {
        border: 'border-cyan-400/55',
        bg: 'bg-cyan-500/10',
        hoverBorder: 'hover:border-cyan-400/70',
        hoverBg: 'hover:bg-cyan-500/15',
        nameColor: 'text-cyan-400',
        buttonBase: 'bg-cyan-500/25 border border-cyan-500/45 text-cyan-100',
        buttonHover: 'hover:bg-cyan-500/40',
        topLine: 'bg-gradient-to-r from-cyan-500/0 via-cyan-400/70 to-cyan-500/0',
    },
};

const DEFAULT_THEME: PlanTheme = {
    border: 'border-white/5',
    bg: 'bg-white/5',
    hoverBorder: 'hover:border-white/10',
    hoverBg: 'hover:bg-white/10',
    nameColor: 'text-white',
    buttonBase: 'bg-white/10 border border-white/5 text-white',
    buttonHover: 'hover:bg-white/20',
    topLine: 'bg-gradient-to-r from-white/0 via-white/20 to-white/0',
};

export function getPlanTheme(planName: string): PlanTheme {
    const lower = String(planName ?? '').toLowerCase();
    if (lower.includes('diamante')) return THEMES.diamante;
    if (lower.includes('ouro')) return THEMES.ouro;
    if (lower.includes('prata')) return THEMES.prata;
    if (lower.includes('bronze')) return THEMES.bronze;
    return DEFAULT_THEME;
}
